/* eslint-disable */

// The regexes have been modified to support lead signup field validations
export const EMAIL_REGEX = /^([a-zA-Z0-9À-ž%+-_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9À-ž\-]+\.)+))([a-zA-ZÀ-ž]{2,4}|[0-9]{1,3})(\]?)$/
export const CANADA_ZIP1_REGEX =
  '[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\\d{1}[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]{1}'
export const CANADA_ZIP2_REGEX = '\\d{1}[A-Za-z]{1}\\d{1}$'
export const US_ZIP_REGEX = /^\d{5}$/
